export const stateSafety = {
  California: {
    name: "California",
    level: "high",
    rights: [
      "Statewide nondiscrimination protections for sexual orientation and gender identity",
      "Legal gender marker changes on state IDs",
      "Ban on conversion therapy for minors",
      "Trans-inclusive healthcare protections",
    ],
  },

  NewYork: {
    name: "New York",
    level: "high",
    rights: [
      "Comprehensive LGBTQ+ nondiscrimination laws",
      "Gender identity protections in employment and housing",
      "Legal recognition of nonbinary identities",
    ],
  },

  Colorado: {
    name: "Colorado",
    level: "high",
    rights: [
        "Strong nondiscrimination laws for sexual orientation and gender identity",
        "Broad access to LGBTQ+ affirming healthcare",
        "Consistent pro-LGBTQ+ legislation and leadership",
    ],
  },

  Florida: {
    name: "Florida",
    level: "medium",
    rights: [
      "No statewide nondiscrimination protections",
      "Restrictions on classroom discussion of LGBTQ+ topics",
      "Local protections may exist depending on city",
    ],
  },

  Texas: {
    name: "Texas",
    level: "low",
    rights: [
      "No statewide LGBTQ+ nondiscrimination protections",
      "Restrictions impacting gender-affirming care",
      "Legal challenges ongoing — rights may change",
    ],
  },
};